export const userInviteOutlet = 'user-invite';
